import MuiTooltip from '@mui/material/Tooltip';
import type { TooltipProps } from './types';

export default function Tooltip(props: TooltipProps) {
  return <MuiTooltip arrow placement="top" {...props} />;
}

export function DelayedTooltip(props: TooltipProps) {
  return <MuiTooltip arrow placement="top" enterDelay={1000} enterNextDelay={1000} {...props} />;
}
